// src/features/license/badges.tsx
// Status → Badge variant mapping for license status and violation severity.

import { Badge } from '@react/components';
import { useI18n } from '@react/hooks';
import { enumKey } from './format';

type Variant = 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'error';

const LICENSE_VARIANTS: Record<string, Variant> = {
  draft: 'default',
  active: 'success',
  expired: 'error',
  grace_period: 'warning',
  suspended: 'warning',
  revoked: 'error',
};

const SEVERITY_VARIANTS: Record<string, Variant> = {
  warning: 'warning',
  soft: 'warning',
  hard: 'error',
};

export function LicenseStatusBadge({ status }: { status?: string }) {
  const { t } = useI18n();
  const key = enumKey(status, 'LICENSE_STATUS_');
  return <Badge variant={LICENSE_VARIANTS[key] ?? 'default'}>{t(`license.status.${key}`)}</Badge>;
}

export function ViolationSeverityBadge({ severity }: { severity?: string }) {
  const { t } = useI18n();
  const key = enumKey(severity, 'VIOLATION_SEVERITY_');
  return <Badge variant={SEVERITY_VARIANTS[key] ?? 'default'}>{t(`license.violationSeverity.${key}`)}</Badge>;
}

export function licenseTypeLabel(t: (k: string) => string, value?: string): string {
  return t(`license.type.${enumKey(value, 'LICENSE_TYPE_')}`);
}

export function validationModeLabel(t: (k: string) => string, value?: string): string {
  return t(`license.validationMode.${enumKey(value, 'VALIDATION_MODE_')}`);
}
